import React from "react";
import { Link } from "react-router-dom";

import EyeIcon from "../../assets/svg/EyeIconDetails.svg";

import { TableBody, TableCell, TableRow, Typography } from "@material-ui/core";
import { APPROVAL_FLOW_ACTIONS, APP_ROUTES } from "../../../config/constants";
import { GetNoDataPresentAfterFiltereApplied, GetNoDataPresentErrorViewUtils } from "../../common/App/AppViewUtils";
import { NO_APPROVAL_REQUEST_FOUND_ERROR, RECORD_INTERFACE } from "./ApprovalRequestConstant";
import { storeRecordDataReducer } from "../Redux/ApprovalRequestSlice";
import { isArrayValid, isEmptyOrNull, isUndefined } from "../../../utils/DataUtils";
import { generateElementIdentifier } from "utils/ApplicationUtils";
import { ELEMENT } from "components/common/App/app-constant";

interface ApprovalRequestTableBodyInterface {
  classes: any;
  rowsData: RECORD_INTERFACE[];
  currentCountry: any;
  appFilterPopUpObj: any;
  appDispatch: any;
}

const ApprovalRequestTableBody = (props: ApprovalRequestTableBodyInterface) => {
  const { classes, rowsData, currentCountry, appFilterPopUpObj, appDispatch } = props;

  const storeRecordDataInSlice = (record: any) => {
    appDispatch(storeRecordDataReducer(record));
  };

  const renderTableCell = (data: string | number) => {
    return (
      <TableCell padding="none" size="small" align="left" className={classes.cellDataStyle}>
        <Typography className={classes.cellDataSpanStyle}>{`${data || "-"}`}</Typography>
      </TableCell>
    );
  };

  const getStatusClassName = (record: RECORD_INTERFACE): string => {
    if (record.approvalStatus === APPROVAL_FLOW_ACTIONS.APPROVED) {
      return classes.approvedStatusStyle;
    } else if (record.approvalStatus === APPROVAL_FLOW_ACTIONS.REJECTED) {
      return classes.rejectedStatusStyle;
    }
    return classes.pendingStatusStyle;
  };

  const isActionTaken = (record: RECORD_INTERFACE): string => {
    let returnText: string = "";
    if (!isUndefined(record) && record.approvalStatus !== APPROVAL_FLOW_ACTIONS.PENDING) {
      returnText = record.actionTakenBy || "-";
    }
    return returnText;
  };

  const isActionTakenDate = (record: RECORD_INTERFACE): string => {
    let returnText: string = "";
    if (!isUndefined(record) && record?.approvalStatus !== APPROVAL_FLOW_ACTIONS.PENDING) {
      returnText = record?.actionDate ?? "-";
    }
    return returnText;
  };

  return (
    <TableBody>
      {!isUndefined(rowsData) && isArrayValid(rowsData) ? (
        rowsData.map((record: RECORD_INTERFACE, recordIndex: number) => (
          <TableRow data-testid={generateElementIdentifier({ key: record?.posNo, customKey:record?.requestedId, element: ELEMENT.TABLE_ROW })} key={`${record?.posNo ?? ""}-${recordIndex}-record-rowsData-ApprovalRequestTableBody`}>
            {renderTableCell(record?.posNo)}
            {renderTableCell(record?.storeName)}
            {renderTableCell(record?.zoneName)}
            {renderTableCell(record?.serviceType)}
            {renderTableCell(record?.requester)}
            {renderTableCell(record?.requestDate)}
            {renderTableCell(record?.activationDate)}
            {renderTableCell(record?.pendingDays)}
            <TableCell padding="none" size="small" align="left" className={classes.cellDataStyle}>
              {!isEmptyOrNull(record?.approvalStatus) ? <div className={getStatusClassName(record)}>{`${record?.approvalStatus || "N/A"}`}</div> : "-"}
            </TableCell>
            {renderTableCell(isActionTaken(record))}
            {renderTableCell(isActionTakenDate(record))}
            <TableCell padding="none" size="small" align="center" className={classes.cellDataStyle}>
              {
                <Link
                  to={{
                    pathname: `${APP_ROUTES.APPROVAL_REQUESTS_DETAILS}`,
                    search: `?posNo=${record?.posNo}&zoneName=${record?.zoneName}&serviceType=${record?.serviceType}&approvalStatus=${record?.approvalStatus}&requestedId=${record?.requestedId}&storeName=${record?.storeName}`,
                  }}
                  onClick={() => storeRecordDataInSlice(record)}
                >
                  <div className={classes.editIconStyle}>
                    <img src={EyeIcon} alt="view config" />
                  </div>
                </Link>
              }
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell rowSpan={1} colSpan={12} className={classes.noDataRowStyle}>
            {!isEmptyOrNull(appFilterPopUpObj.isDataFetched) && appFilterPopUpObj?.isDataFetched ? (
              <GetNoDataPresentAfterFiltereApplied />
            ) : (
              <GetNoDataPresentErrorViewUtils currentCountry={currentCountry} ErrorMessage={NO_APPROVAL_REQUEST_FOUND_ERROR} SecondaryErrorMessage={""} />
            )}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};

export default ApprovalRequestTableBody;
